import { atom } from "jotai"

export const userInputAtom = atom("")
export const stepAtom = atom<number | undefined>(undefined)
export const petitionTypeAtom = atom("")
export const userInputContractAtom = atom("")
export const toFavorAtom = atom("")
export const blockQuoteMarginAtom = atom("0")